import styled from "@emotion/styled";

import { SectionSearchResultListItem } from "./item";

export const StyledSectionSearchResultListItem = styled(SectionSearchResultListItem)``;

export const Container = styled.div`
  padding-block: 20px;

  border-block: 1px solid rgba(0, 0, 0, 0.2);

  ${StyledSectionSearchResultListItem}:not(:last-of-type) {
    margin-block-end: 20px;
  }
`;

export const Title = styled.p`
  margin-block-end: 4px;

  font-size: 14px;
`;
